import {useCallback, useState} from 'react';

import type {RenderSlideProps} from 'yet-another-react-lightbox';

import {useController, useLightboxProps} from 'yet-another-react-lightbox';

import {LoadingSpinner} from '../../../../../uikit/LoadingSpinner';
import * as S from './styles';

export const HtmlContentSlide = ({slide}: RenderSlideProps) => {
  const [isLoading, setIsLoading] = useState(true);

  const lightboxProps = useLightboxProps();
  const controller = useController();

  const onContainerClick = () => {
    if (lightboxProps.controller.closeOnBackdropClick) {
      controller.close();
    }
  };

  const onLoad = useCallback(() => {
    setIsLoading(false);
  }, []);

  return (
    <S.Container onClick={onContainerClick}>
      <iframe
        id={slide.src}
        onLoad={onLoad}
        sandbox="allow-same-origin"
        src={slide.src}
      />
      {isLoading ? (
        <S.LoadingSpinnerContainer>
          <LoadingSpinner size={50} />
        </S.LoadingSpinnerContainer>
      ) : null}
    </S.Container>
  );
};
